import List from "./List";
import New from "./New";
import Properties from "./Properties";
import Body from "./Body";
import Detail from "./Detail";

export default {
  List,
  New,
  Properties,
  Body,
  Detail
};
